<template>
  <div class="animated fadeIn">
    <b-card v-if="partner" header="Partner Info">
      <b-row>
        <b-col md="6">
          <table class="table table-sm table-borderless">
            <tbody>
              <tr>
                <th scope="row">Name</th>
                <td>: {{ partner.name }}</td>
              </tr>
              <tr>
                <th scope="row">Email</th>
                <td>: {{ partner.email }}</td>
              </tr>
              <tr>
                <th scope="row">Total Incentive</th>
                <td>: {{ partner.incentive_saldo | toRupiah }}</td>
              </tr>
              <tr>
                <th scope="row">Total Deposit</th>
                <td>: {{ partner.deposit_saldo | toRupiah }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th scope="row">Buy Incentive Type</th>
                <td>{{ partner.buy_incentive_type }}</td>
              </tr>
              <tr>
                <th scope="row">Buy Margin</th>
                <td>{{ partner.buy_margin }}%</td>
              </tr>
              <tr>
                <th scope="row">Basic Buy Price</th>
                <td>{{ partner.basic_buy_price | toRupiah }}</td>
              </tr>
              <tr>
                <th scope="row">Partner Buy Price</th>
                <td>{{ partner.partner_buy_price | toRupiah }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
        <b-col md="6">
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th scope="row">Sell Incentive Type</th>
                <td>{{ partner.sell_incentive_type }}</td>
              </tr>
              <tr>
                <th scope="row">Sell Margin</th>
                <td>{{ partner.sell_margin }}%</td>
              </tr>
              <tr>
                <th scope="row">Basic Sell Price</th>
                <td>{{ partner.basic_sell_price | toRupiah }}</td>
              </tr>
              <tr>
                <th scope="row">Partner Sell Price</th>
                <td>{{ partner.partner_sell_price | toRupiah }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { store } from '@/shared/store'
import { getPartnerInfo, handleError } from '@/services/metal'
import { toRupiah } from '@/shared/utils'
export default {
  name: 'Dashboard',

  filters: {
    toRupiah: function(val) {
      return toRupiah(val)
    }
  }, // filters

  data() {
    return {
      partner: null
    }
  }, // data

  created() {
    store.setIsInitLoading(true)
    getPartnerInfo()
      .then(response => {
        this.partner = response.data.data
        store.setIsInitLoading(false)
      })
      .catch(error => {
        handleError(error)
      })
  }, // created
}
</script>
